import { buildInvoicesPDF } from "./invoicesPDF";
import { showDocument } from "../../../controllers/api_invoices";
import { getClientLogo } from "../../../controllers/api_clients";
import { toast, ToastContainer } from "react-toastify";

/**
 * Genera PDF de factura.
 * @param {string} invoiceId - ID de la factura
 * @param {"download"|"view"} mode - "download" para descargar, "view" para visor
 */
export const generateInvoicesPDF = async (invoiceId, mode = "download") => {
  try {
    const data = await showDocument(invoiceId);
    if (!data?.items?.length) {
      toast.info(`El documento ${data.documento.numero_documento || data.documento.numero_factura} no presenta lineas asociadas.`);
      return;
    }

    if (data.emisor.logo_url) {
      const empresa_id = data.emisor.logo_url.split("/")[3];
      data.emisor.logo_base64 = await getClientLogo(empresa_id);
    }

    return await buildInvoicesPDF(data, invoiceId, mode);
  } catch (err) {
    console.error("Error generando PDF", err);
    toast.error("Error generando PDF");
  }
};

/**
 * (2026-05-21) Genera el PDF de una factura como string base64.
 *
 * Lo usa el flujo de notificacion automatica por correo: el cliente arma
 * el PDF de la factura recien creada (o de una pendiente del batch retry)
 * y lo envia al backend en el body de POST /api/invoices/<id>/notificar-email.
 *
 * Devuelve `null` si el documento no tiene items o si la generacion falla
 * — el caller debe manejar ese caso (queda como pendiente).
 *
 * NO dispara recordPrintout (no es una descarga del operador, es un envio
 * automatico del sistema).
 */
export const generateInvoicesPDFBase64 = async (invoiceId) => {
  try {
    const data = await showDocument(invoiceId);
    if (!data?.items?.length) {
      console.warn(`generateInvoicesPDFBase64: factura ${invoiceId} sin items`);
      return null;
    }
    if (data.emisor?.logo_url) {
      const empresa_id = data.emisor.logo_url.split("/")[3];
      try {
        data.emisor.logo_base64 = await getClientLogo(empresa_id);
      } catch (e) {
        // No es bloqueante: el PDF se genera sin logo si la carga falla.
        console.warn("generateInvoicesPDFBase64: no se pudo cargar logo", e);
      }
    }
    const b64 = await buildInvoicesPDF(data, invoiceId, "base64");
    return b64 || null;
  } catch (err) {
    console.error("Error generando PDF (base64)", err);
    return null;
  }
};
